import { system } from "../system";
export var Properties;
(function (Properties) {
    function entries(properties) {
        return system.Object.entries(properties);
    }
    Properties.entries = entries;
    function getName(properties) {
        return `{ ${Properties.entries(properties)
            .map(([p, t]) => `${p.toString()}: ${t.name}`)
            .join(", ")} }`;
    }
    Properties.getName = getName;
    function prune(properties, value) {
        return system.Object.fromEntries(Properties.entries(properties)
            .map(([p, t]) => [p, t.prune(value[p])])
            .filter(([p, v]) => v !== undefined));
    }
    Properties.prune = prune;
    function optional(properties) {
        return system.Object.fromEntries(Properties.entries(properties).map(([p, t]) => [p, t.optional()]));
    }
    Properties.optional = optional;
})(Properties || (Properties = {}));
//# sourceMappingURL=Properties.js.map